/* eslint-disable @stylistic/max-len */
import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Form } from 'react-bootstrap';
import type { CountrySelectorTypedProps } from './types';
import type { AddressCountryStore } from '../Store/entities/addressStates';

const CountrySelectorTyped = ({
	currentCountryCode,
	onChange,
	disabled = false,
	isValid = true,
	isInvalid = false,
	feedbackMessage = '',
	className = ''
}: CountrySelectorTypedProps & {
	isInvalid?: boolean;
	feedbackMessage?: string;
}) => {
	const countries: AddressCountryStore[] = [
		{ id: 1, name: 'United States', code: 'US' },
		{ id: 2, name: 'Canada', code: 'CA' },
		{ id: 3, name: 'New Zealand', code: 'NZ' },
		{ id: 4, name: 'United Kingdom', code: 'UK' }
	];

	const selectedCountryObj = countries.find((country) =>
		(country.code.toLowerCase() === (currentCountryCode || "").toLowerCase())
			|| (country.name.toLowerCase() === (currentCountryCode || "").toLowerCase()));
	const selectedCountry = selectedCountryObj ? [selectedCountryObj] : [];
	const validationClass = isInvalid ? 'is-invalid' : (isValid && currentCountryCode) ? 'is-valid' : '';

	return (
		<Form.Group>
			<Form.Label className={className}>
				Country
				<Typeahead
					id="country-select"
					clearButton
					paginate
					flip
					placeholder="Select Country..."
					options={countries}
					disabled={disabled}
					labelKey="name"
					selected={selectedCountry || []}
					onChange={(selection) => {
						const selected = selection[0] as AddressCountryStore | undefined;
						onChange(selected?.code ?? '');
					}}
					inputProps={{
						autoComplete: "new-password",
						className: validationClass
					}}
					className={`form-control p-0 ${validationClass}`}
				/>
				{isInvalid && <Form.Control.Feedback type="invalid" className="d-block">{feedbackMessage}</Form.Control.Feedback>}
				{currentCountryCode && isValid && !isInvalid && <Form.Control.Feedback type="valid" className="d-block">Looks good!</Form.Control.Feedback>}
			</Form.Label>
		</Form.Group>
	);
};

export default CountrySelectorTyped;
